// Components==============
import { motion } from 'framer-motion';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { getVh } from 'utilities/getVh';
import { GlobalContext } from 'utilities/GlobalContext';
import './ExerciseWrapper.module.scss';
// =========================

export default function ExerciseWrapper({
    children,
    disableOverflow = false,
    padding,
    fullWidth,
}: {
    children: React.ReactNode;
    disableOverflow?: boolean;
    padding?: string;
    fullWidth?: boolean;
}) {
    const { selected, keyboardIsOpen } = useContext(GlobalContext);
    const [x, setX] = useState(0);

    const transition = {
        type: 'spring',
        duration: 0.8,
        bounce: 0.25,
        opacity: { delay: 0.25 },
        scale: { delay: 0.25 },
    };

    const ref = useRef<HTMLDivElement>(null!);

    const exerciseWidth = ref?.current?.clientWidth;
    const windowWidth = document.querySelector('body')?.clientWidth;
    const requiredWidth =
        selected === 'city' ? 580 : selected === 'dog' ? 980 : 0;

    useEffect(() => {
        if (exerciseWidth && windowWidth) {
            if (windowWidth - exerciseWidth > requiredWidth)
                return setX(-requiredWidth / 2);
            setX(0);
        }
    }, [exerciseWidth, windowWidth, requiredWidth]);

    return (
        <motion.div
            styleName="wrapper"
            animate={{
                opacity: 1,
                scale: 1,
                x,
                y: keyboardIsOpen ? -128 : 0,
            }}
            ref={ref}
            style={{
                maxHeight: keyboardIsOpen
                    ? `${getVh(1)} - 525px)`
                    : `${getVh(1)} - 225px`,
                overflowY: disableOverflow ? 'initial' : 'auto',
                width: fullWidth ? '100%' : 'initial',
                padding,
            }}
            initial={{ opacity: 0, scale: 0.9, x: 0, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, x: 0, y: 0 }}
            transition={transition}
        >
            {children}
        </motion.div>
    );
}
